import React, {Fragment, useState, useEffect} from "react";
import queryString from "query-string";

import MyResourcesTable from "root/Tables/MyResourcesTable";
import './ResourcesTab.scss';

import useModalAddResource from "root/Modals/AddResource/useModalAddResource";
import {getMyResources} from "root/DataFunctions/ResourceDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {useLocation} from "react-router-dom";
import {ResourceType} from "root/DataFunctions/Constants";
import ActionButton from "root/Wieldy/ApplicationModules/Common/Components/ActionButton";

const ResourcesTab = (props) =>
{
    const [data, setData] = useState({loading: true, data: []});

    const [renderAddResourceModal, showAddResourceModal] = useModalAddResource((result) =>
    {
        if (result === 'saved')
        {
            getData();
        }
    })

    const resourceFilterDefault = 'feelings';
    const { search } = useLocation();
    const queryParams = queryString.parse(search) ;
    const resourceFilter = queryParams.type === undefined?resourceFilterDefault:queryParams.type;

    useEffect(() => {
        getData();
    }, [resourceFilter]);

    const getMyId = () =>
    {
        return phpVars.user_id;
    }

    const getData = () => {
        getMyResources( getMyId(), getResourceType(),(response) =>
        {
            const data = getDataFromResponse( response ) ;
            setData({ isLoading: false, data: data});
        });
    }

    const getResourceType = () => {
        let resourceType = null;

        switch (resourceFilter){
            case 'feelings':
                resourceType = ResourceType.FEELINGS
                break
            case 'game':
                resourceType = ResourceType.GAME
                break
            case 'learning':
                resourceType = ResourceType.LEARNING
                break
            case 'help':
                resourceType = ResourceType.HELP
                break
            default:
                resourceType = ResourceType.ALL
        }

        return resourceType;
    }

    const clickHandler = (mode, resource_id) =>
    {
        showAddResourceModal(mode, resource_id, props.child_uid);
    }

    return (
        <Fragment>
            <div className="family-body">
                <MyResourcesTable child_uid={props.child_uid} loading={data.loading} data={data.data} clickHandler={clickHandler}/>
            </div>

            {renderAddResourceModal(props)}
        </Fragment>
    )
}

ResourcesTab.defaultProps = {};

export default ResourcesTab;

